<div id="app" class="h-100 app"
                [ngClass]="settings.theme"
                [class.main-toolbar-fixed]="settings.mainToolbarFixed"
                [dir]="!(settings.rtl) ? 'rtl' : 'ltr'">
    <!-- Replaces the old private-preview password prompt -->
    @if (showConstructionBanner) {
      <div class="construction-banner" role="status" dir="rtl">
        <span class="construction-banner__text">🚧 האתר בהרצה — חלק מהשירותים עדיין בהקמה. נשמח לשמוע מכם:
          <a routerLink="/contact">צור קשר</a></span>
        <button type="button" class="construction-banner__close" (click)="hideConstructionBanner()" aria-label="סגירת ההודעה">✕</button>
      </div>
    }
    @if (showEnvRibbon) {
      <div class="env-ribbon" aria-hidden="true">{{ envLabel | uppercase }}</div>
    }
    <router-outlet></router-outlet>
    <app-toast-container></app-toast-container>
    <app-notification-container></app-notification-container>
<!--    <ngx-spinner bdColor="rgba(51,51,51,0.7)" size="large" color="#fff" type="ball-clip-rotate"></ngx-spinner>-->
    @if (showGlobalChatbot) {
      <app-chatbot></app-chatbot>
    }
</div>
